import Mention from './src/mention2.mjs';
export { mentionEmits, mentionProps } from './src/mention.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElMention = withInstall(Mention);

export { ElMention, ElMention as default };
//# sourceMappingURL=index.mjs.map
